import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {newsletterMailEdit_template} from "../components/templates/newsletterMailEdit_template";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";
import NwsLAB, {StylesOptions} from '../utils/NewsletterArticlePickerBuilder';
import {downloadTargetedEmailCsv} from "../utils/TargetedEmailCsvExporter";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let contentEditor;
let imageDescriptionEditor;
let imageCaptionEditor;
let bulkImageCaptionEditor;
let bulkImageDescriptionEditor;

export class newsletter_mail_edit extends vnModule_knockoutJS {

    protected newsletterMailEditTemplate: newsletterMailEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    private imageMode: string;
    private XHRHdlCaller: string;
    private contentImageXHRHdl: any;
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
    private recipientCountRequestId: number = 0;
    private debouncedRecipientCount: (...args: any[]) => void;

    protected getVideoPickerHelper() {
        return this.newsletterMailEditTemplate.videoPickerHelper;
    }

    buildContent(): Element[] {
        this.newsletterMailEditTemplate = new newsletterMailEdit_template("newsletterBuilder_template", this.viewModel, this);

        return [this.newsletterMailEditTemplate.build()];
    }

    protected getModuleName(): string {
        return "newsletterMailEdit_template";
    }

    protected getImagePickerHelper() {
        return this.newsletterMailEditTemplate.imagePickerHelper;
    }

    public fillPage(): void {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.getVideoPickerHelper().getVideoReferences();
        }

        this.getNewsletterReferences();
        this.newsletterMailEditTemplate.buildDatePickerCalendar();
        this.initializeCkEditors();
    }

    protected getUploadUrlSubtitles(): string {
        return this.getVideoPickerHelper().getUploadUrlSubtitles();
    }

    protected showImagePicker(mode, target) {

        if (typeof target.name !== 'undefined' && target.name !== null){
            target = target.name; // @TODO revisit
        }

        this.newsletterMailEditTemplate.showImagePicker(mode, target);

    }

    protected showTagPicker(editor) {

        this.newsletterMailEditTemplate.tagPicker.resetPagination();
        this.getTagData();

        this.newsletterMailEditTemplate.showTagPicker("in-content", editor.name);
    }

    protected addUpdateBlock(editor) {
        const d = new Date();
        const dformat = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('/') + ' '
            + [('0' + d.getHours()).slice(-2), ('0' + d.getMinutes()).slice(-2)].join(':') + " EST";
        const authorName = this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
        const tag = '<div class="emaki-custom update"><h3>UPDATE: ' + dformat + ' BY ' + authorName.toUpperCase() + '</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>';

        const tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
        editor.insertElement(tagElement);
    }

    private destroyAllCkEditorInstances(): void {
        Object.keys(CKEDITOR.instances).forEach(instance => {
            CKEDITOR.instances[instance].destroy(true);
        });
    }


    protected initializeCkEditors(mode :string|null = 'regular') {

        const customStyles = [
            {name: 'Heading 1', element: 'h1'},
            {name: 'Heading 2', element: 'h2'},
            {name: 'Heading 3', element: 'h3'},
            {name: 'Preformatted', element: 'pre'},
            {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
            {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
            {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
            {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
            {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
            {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
            {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
            {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
            {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
            {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}}
        ];

        const minimalStyles = [
            {name: 'Heading 2', element: 'h2'},
            {name: 'Heading 3', element: 'h3'}
        ];

        this.destroyAllCkEditorInstances();
        delete CKEDITOR.stylesSet.registered.my_styles;

        if(mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE){
            CKEDITOR.stylesSet.add('my_styles', minimalStyles);
        }else {
            CKEDITOR.stylesSet.add('my_styles', customStyles);
        }

        this.configureDialogDefinitions();
        const allEditors = this.initializeEditors(mode);


        if(mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE){
            this.addImagePickerCommand(allEditors);
            this.addInsertArticleCommand(allEditors);
            this.addLinkToolCommand(allEditors);
            this.addUpdateBlockCommand([ contentEditor, imageDescriptionEditor, imageCaptionEditor ]);
            this.addOnClickContentHandler([contentEditor], mode );
            // this.addHeadingStyleHandler(contentEditor)
            this.addHorizontalLineHandler(contentEditor);
            this.addParagraphStyleHandler(contentEditor);
            this.blockquoteCommandHandler(contentEditor);
            this.commandListenerHandler(contentEditor);
            this.cleanListStylesHandler(contentEditor);
        }else{
            this.addImagePickerCommand(allEditors);
            this.addInsertArticleCommand(allEditors);
            this.addLinkToolCommand(allEditors);
            this.addUpdateBlockCommand([ contentEditor, imageDescriptionEditor, imageCaptionEditor ]);
            this.addOnClickContentHandler( [contentEditor]);
            this.addTagPickerCommand([ contentEditor ]);
            this.newsletterMailEditTemplate.initTagPickerCkEditors();
        }

        if (!CKEDITOR.plugins.registered.editMenu) {
            CKEDITOR.plugins.add("editMenu", {
                init: function (editor) {
                    editor.ui.addRichCombo("EditMenu", {
                        label: "Edit",
                        title: "Edit",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
    
                        init: function () {
                            this.add("Cut", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -312px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Cut", "Cut");
                            this.add("Copy", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -264px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Copy", "Copy");
                            this.add("Paste", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -360px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Paste", "Paste");
                        },
    
                        onClick: function (value) {
                            try {
                                editor.focus();
                            } catch (_) {}
    
                            switch (value) {
                                case "Cut":
                                    editor.execCommand("cut");
                                    break;
                                case "Copy":
                                    editor.execCommand("copy");
                                    break;
                                case "Paste":
                                    editor.execCommand("paste");
                                    break;
                            }
                        },
                    });
                },
            });
        }
    }

    private initializeEditors(mode = 'regular') {
        const allEditors = [];

        this.initCkEditor('contenttext', mode);
        contentEditor = CKEDITOR.instances.contenttext;
        allEditors.push(contentEditor);

        this.initCkEditor('image_description');
        imageDescriptionEditor = CKEDITOR.instances.image_description;
        allEditors.push(imageDescriptionEditor);

        this.initCkEditor('image_caption');
        imageCaptionEditor = CKEDITOR.instances.image_caption;
        allEditors.push(imageCaptionEditor);

        const that = this;

        this.initCkEditor('bulk_image_description');
        bulkImageDescriptionEditor = CKEDITOR.instances.bulk_image_description;
        bulkImageDescriptionEditor.on('change', function () {
            that.newsletterMailEditTemplate.imagePicker.imagesBulkEdit.getTemplateViewModel().description(this.getData());
        });
        allEditors.push(bulkImageDescriptionEditor);

        this.initCkEditor('bulk_image_caption');

        bulkImageCaptionEditor = CKEDITOR.instances.bulk_image_caption;
        bulkImageCaptionEditor.on('change', function () {
            that.newsletterMailEditTemplate.imagePicker.imagesBulkEdit.getTemplateViewModel().caption(this.getData());
        });
        allEditors.push(bulkImageCaptionEditor);
        return allEditors;
    }

    private configureDialogDefinitions() {
        CKEDITOR.on('dialogDefinition', ev => {
            const dialogName = ev.data.name;
            const dialogDefinition = ev.data.definition;
            const editor = ev.editor;

            if (dialogName === "cellProperties") {
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor");
                cellProps.remove("bgColor");
            }

            if (dialogName === 'table') {
                dialogDefinition.removeContents('advanced');
                const infoTab = dialogDefinition.getContents('info');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }

            if (dialogName === 'link') {
                const targetTab = dialogDefinition.getContents('target');
                const informationTab = dialogDefinition.getContents('info');
                informationTab.remove('browse');
                const targetField = targetTab.get('linkTargetType');
                targetTab.remove('linkTargetType');
                informationTab.add(targetField);
                const mode = this.getNewsLetterMode();
                const {primaryColor} = this.getColorSet();

                if(editor.name === 'contenttext' && (mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE)){
                    let linkColorSettings = {
                        type: 'text',
                        id: 'linkColor',
                        label: 'Link Color',
                        style: 'display:none'
                    } as any;
                    if(primaryColor || primaryColor !== ''){
                        linkColorSettings = { ... linkColorSettings, default : primaryColor};
                    }
                    informationTab.add(linkColorSettings);
                }
            }
        });
    }

    protected addUpdateBlockCommand(editors) {
        const _myThis = this;

        editors.forEach(function (editor) {
            function addUpdateBlock(obj) {

                return {
                    exec (instance) {
                        _myThis.addUpdateBlock(instance);
                    }
                };
            }

            editor.addCommand("updateBlockCommand", addUpdateBlock(this));

            editor.ui.addButton('UpdateBtn', {
                label: "Update",
                command: 'updateBlockCommand',
                toolbar: 'insert'

            });
        });
    }


    protected initCkEditor(idElement, mode = 'regular') {
        const editorConfig = {
            height: '500px',
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'p(*){*}[*];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a(*)',
            disallowedContent: '',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: { element: 'p' }
        };

        const colorSet = this.getColorSet();
        const {primaryColor, secondaryColor} = colorSet;

        const minimalEditorConfig = {
            height: '500px',
            toolbar: 'MA',
            extraAllowedContent: 'p(*){*}[*];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];blockquote(*){*}[*];a[rel];a[target];a(*)',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            // stylesSet: 'my_styles',
            format_tags: "p;h2;h3",
            format_p: { element: 'p' },
            extraPlugins: 'customtabletitles',
            customTableTitlesColors: {
                // h2: primaryColor || '#000000',
                h2: '#333',
                h3: secondaryColor || '#000000'
            },
            customTableTitlesPaddingBottom : {
                h2: '20px',
                h3: '18px'
            }
        };

        if ((mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE) && idElement === 'contenttext') {
            CKEDITOR.replace(idElement, minimalEditorConfig);
        } else {
            CKEDITOR.replace(idElement, editorConfig);
        }

        const editor = CKEDITOR.instances[idElement];

        if((mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE) && idElement === 'contenttext'){
            editor.config.enterMode = CKEDITOR.ENTER_P;
            editor.config.shiftEnterMode = CKEDITOR.ENTER_P;
        } else {
            editor.config.enterMode = CKEDITOR.ENTER_BR;
            editor.config.shiftEnterMode = CKEDITOR.ENTER_BR;
        }

        // The parser drops a body tag before the content filter runs, so the tag is shielded as
        // protected source instead. This keeps a hand written body tag intact across the source
        // and wysiwyg round trip.
        if (mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE && idElement === 'contenttext') {
            editor.config.protectedSource = [/<body\b[^>]*>/gi, /<\/body\s*>/gi];
        }

        // Shared configuration
        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=2.5'];
        CKEDITOR.config.skin = "emakiCustomComprehensive";
        CKEDITOR.config.extraPlugins += ',wordcount,notification,editMenu';
        CKEDITOR.config.forcePasteAsPlainText = true;
        CKEDITOR.config.wordcount = { showParagraphs: false, showWordCount: true, showCharCount: true };
        CKEDITOR.config.allowedContent = true;

        // Configuration toolbar
        if ((mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE) && idElement === 'contenttext') {
            editor.config.toolbar_MA = [
                [
                    'Source', '-',
                    'EditMenu', '-',
                    'Undo', 'Redo', 'RemoveFormat', '-',
                    'Link', 'Unlink', '-',
                    'Table', 'HorizontalRule', 'SpecialChar', 'CustomTableTitles', '-',
                    'ImgBtn', 'ArticleBtn',"-",
                    'Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', 'Blockquote', '-'
                ],
                [ 'Maximize']
            ];
        } else {
            editor.config.toolbar_MA = [
                ['Source', '-', 'EditMenu', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule',
                    'SpecialChar', 'ImgBtn', 'Styles', 'ArticleBtn', 'TagBtn','-','Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote'],
                [ 'Maximize']
            ];
        }
    }

    protected addLinkToolCommand(editors) {
        editors.forEach(function (editor) {
            function showLinkTool(obj) {
                return {
                    exec (editor) {
                        obj.showLinkTool();
                    }
                };

            }

            editor.addCommand("linkToolCommand", showLinkTool(this));

            editor.ui.addButton('LinkBtn', { // add new button and bind our command
                label: "Link Tool",
                command: 'linkToolCommand',
                toolbar: 'insert'
            });
        });
    }

    protected showLinkTool() {
        const url = "https://datastudio.google.com/u/0/reporting/1JtF204Vz8MIa9DhToLzu4Ou2bIqTSuVt/page/4uYeB";
        // launch the link tool in new tab
        const element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected addTagPickerCommand(editors) {

        const _myThis = this;
        editors.forEach(function (editor) {

            function showMyDialog(obj) {

                return {
                    exec (editor) {
                        _myThis.showTagPicker(editor);
                    }
                };
            }

            editor.addCommand("tagPickerCommand", showMyDialog(this));

            editor.ui.addButton('TagBtn', { // add new button and bind our command
                label: "Insert Tags",
                command: 'tagPickerCommand',
                toolbar: 'insert',
                icon: '/assets/images/tag.png'
            });
        });
    }

    protected addInsertArticleCommand(editors){
        const _myThis = this;

        editors.forEach(function (editor) {
            function showInsertArticledDialog(obj) {
                return {
                    exec (editor) {
                        _myThis.showInsertArticlePopUp(editor);
                    }
                };
            }

            editor.addCommand("insertArticleCommand", showInsertArticledDialog(this));

            editor.ui.addButton('ArticleBtn', { // add new button and bind our command
                label: "Insert Article",
                command: 'insertArticleCommand',
                toolbar: 'insert',
                icon: '/assets/images/article.png'
            });
        });
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit() {
        const brandId = this.getVnAppZone().app.params.idBrand;
        page.redirect("/brand/" + brandId + "/newsletter/emails/");
        // this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Edit static page canceled !");
    }

    protected addImagePickerCommand(editors) {
        const _myThis = this;

        editors.forEach(function (editor) {

            function showMyDialog(obj) {

                return {
                    exec (editor) {
                        _myThis.showImagePicker("single-select", editor);
                    }
                };
            }

            editor.addCommand("imagePickerCommand", showMyDialog(this));

            editor.ui.addButton('ImgBtn', { // add new button and bind our command
                label: "Insert Images",
                command: 'imagePickerCommand',
                toolbar: 'insert',
                icon: '/node_modules/ckeditor4/plugins/image2/icons/image.png'
            });
        });
    }

    protected save(type) {
        this.loadingIn(this.newsletterMailEditTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        const formReq_url: string = '/api/brand/' + idBrand + "/newsletter/emails/save/";
        const formReq_params: string[][] = [];

        this.newsletterMailEditTemplate.getTemplateViewModel().content(contentEditor.getData());

        const subViewModel = JSON.parse(ko.toJSON(this.newsletterMailEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        // formReq_params.push(["contentNodeList", ko.toJSON(subViewModel)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        if (type == "stay") {
            XHRHdl.onReadyStateFunction = this.onStayReturn;

        } else if (type == "save") {
            XHRHdl.onReadyStateFunction = this.onSaveReturn;
        }

        XHRHdl.execute();
    }

    protected sendNewsletter() {
        this.loadingIn(this.newsletterMailEditTemplate.getNewsletterConfirmElement());

        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        const formReq_url: string = '/api/brand/' + idBrand + "/newsletter/emails/send/";
        const formReq_params: string[][] = [];

        this.newsletterMailEditTemplate.getTemplateViewModel().content(contentEditor.getData());

        const subViewModel = JSON.parse(ko.toJSON(this.newsletterMailEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter Delivery Scheduled !");
                        obj.newsletterMailEditTemplate.toggleSaveAndSendPopUp(false);

                        obj.redirectToMailList();
                    }

                });
                obj.loadingOut(obj.newsletterMailEditTemplate.getNewsletterConfirmElement());

            };
        });

        XHRHdl.execute();
    }

    public scheduleRecipientCount() {
        if (!this.debouncedRecipientCount) {
            this.debouncedRecipientCount = this.debounce(() => this.refreshRecipientCount(), 400);
        }
        this.debouncedRecipientCount();
    }

    public refreshRecipientCount() {
        const viewModel = this.newsletterMailEditTemplate.getTemplateViewModel();
        if (!viewModel.isSaveAndSendPopUpVisible()) {
            return;
        }

        this.recipientCountRequestId += 1;
        const requestId = this.recipientCountRequestId;
        viewModel.isRecipientCountLoading(true);

        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + "/newsletter/emails/recipient-count/";
        const formReq_params: string[][] = [];
        const subViewModel = JSON.parse(ko.toJSON(this.newsletterMailEditTemplate.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        if (requestId !== obj.recipientCountRequestId) {
                            return;
                        }
                        if (req.request.status === 200) {
                            const responseParsed = JSON.parse(req.request.response);
                            viewModel.recipientCount(responseParsed.count);
                        }
                    });
                } finally {
                    if (requestId === obj.recipientCountRequestId) {
                        viewModel.isRecipientCountLoading(false);
                    }
                }
            }
        });
        XHRHdl.execute();
    }

    public exportAudience(): void {
        this.newsletterMailEditTemplate.setAudienceExportLoading(true);
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const url = '/api/brand/' + idBrand + '/newsletter/emails/audience-export/';
        const params: string[][] = [];
        params.push(['data', ko.toJSON(this.newsletterMailEditTemplate.getViewModelForRequest())]);

        const XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function (req, obj) {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        const responseParsed = JSON.parse(req.request.response);
                        downloadTargetedEmailCsv(responseParsed.emails || [], 'newsletter-targeted-emails.csv');
                    });
                } finally {
                    obj.newsletterMailEditTemplate.setAudienceExportLoading(false);
                }
            };
        };
        XHRHdl.execute();
    }

    public lookupAudience(): void {
        const requestData = this.newsletterMailEditTemplate.getAudienceLookupRequest();
        if (!requestData.emails.length) {
            this.newsletterMailEditTemplate.setAudienceLookupResults([]);
            return;
        }

        this.newsletterMailEditTemplate.setAudienceLookupLoading(true);
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + "/newsletter/emails/audience-lookup/";
        const formReq_params: string[][] = [];
        formReq_params.push(["data", ko.toJSON(requestData)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        if (req.request.status === 200) {
                            const responseParsed = JSON.parse(req.request.response);
                            obj.newsletterMailEditTemplate.setAudienceLookupResults(responseParsed.results || []);
                        }
                    });
                } finally {
                    obj.newsletterMailEditTemplate.setAudienceLookupLoading(false);
                }
            }
        });
        XHRHdl.execute();
    }

    protected onSaveReturn (req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter Message saved !");
                    // obj.getVnAppZone().showNotificationToModule();
                    obj.redirectToMailList();
                }

            });
            obj.loadingOut(obj.newsletterMailEditTemplate.builtTemplate);

        };
    }

    protected onStayReturn (req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter Message saved !");
                    obj.getVnAppZone().showNotificationToModule();
                }

            });
            obj.loadingOut(obj.newsletterMailEditTemplate.builtTemplate);

        };
    }

    protected redirectToMailList(){

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + "/newsletter/emails/");
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterMailEditTemplate.builtTemplate);

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/references';
        const usrReq_params: string[][] = [['references', 'badges,permissions,recipients,templates,mailingLists,segments,campaigns,fields,operators,utmSources,profileOptions']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public loadProfileOptions(field: string, callback: Function): void {
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/references/';
        let XHRHdl = new XMLHttpRequestHandler(url, [['profileField', field]], this);
        XHRHdl.onReadyStateFunction = (req, obj) => () => {
            obj.manageResponse(req, obj, () => callback(JSON.parse(req.request.response).data || []));
        };
        XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterMailEditTemplate.builtTemplate);

                // check if user has article write permissions
                const responseParsed = JSON.parse(req.request.response);

                obj.newsletterMailEditTemplate.tagPicker.setTagViewBadgeOptions(responseParsed.badges);
                obj.newsletterMailEditTemplate.setPermissions(responseParsed.permissions)
                obj.newsletterMailEditTemplate.setRecipients(responseParsed.recipients)
                obj.newsletterMailEditTemplate.setTemplates(responseParsed.templates)
                obj.newsletterMailEditTemplate.setAvailableNewsLetterTemplates(responseParsed.templates)
                obj.newsletterMailEditTemplate.setPermissions(responseParsed.permissions);
                obj.newsletterMailEditTemplate.setRecipients(responseParsed.recipients);
                obj.newsletterMailEditTemplate.setTemplates(responseParsed.templates);
                obj.newsletterMailEditTemplate.setAvailableNewsLetterTemplates(responseParsed.templates);
                obj.newsletterMailEditTemplate.setTargetingReferences(responseParsed)

                if (obj.getVnAppZone().app.params.id){
                    obj.getNewsletterMailDataForEdit();
                }
            });
        };
    }


    protected getTagData() {

        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }

        this.newsletterMailEditTemplate.tagPicker.showLoading();

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + '/tags/get/';
        const formReq_params: string[][] = [];

        // let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        const viewModel = this.newsletterMailEditTemplate.tagPicker.getViewModelForRequest();
        /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.tagSearchXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    protected onGetTagDataReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateTagPickerForm(responseParsed);
                obj.newsletterMailEditTemplate.tagPicker.hideLoading();
                /*if(obj.newsletterMailEditTemplate.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }*/
            });
        };
    }

    // image picker functions
    protected getImageData(keyword = null) {

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.newsletterMailEditTemplate.imagePicker.showLoading();

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + '/images/get/';
        const formReq_params: string[][] = [];

        // let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        const viewModel = this.newsletterMailEditTemplate.imagePicker.getViewModelForRequest();
        /*if(keyword != null){
            viewModel.filters.keywords(keyword);
        }*/
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.newsletterMailEditTemplate.imagePicker.hideLoading();
                if(obj.newsletterMailEditTemplate.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
            });
        };
    }

    protected updateImagePickerForm(responseParsed) {
        const selectedImages = this.newsletterMailEditTemplate.imagePicker.getSelectedImages();

        if( responseParsed.paginatedImages && responseParsed.paginatedImages.data ){
            for(const image of responseParsed.paginatedImages.data){
                image.selected = false;
                const imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.newsletterMailEditTemplate.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.newsletterMailEditTemplate.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }

        if (responseParsed.imagesInContent) {
            for (const image of responseParsed.imagesInContent) {
                image.selected = false;
                const imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.newsletterMailEditTemplate.imagePicker.setImagesInContent(responseParsed.imagesInContent);
        }

        const selectedGallery = this.newsletterMailEditTemplate.imagePicker.getSelectedGallery();

        if( responseParsed.paginatedGalleries && responseParsed.paginatedGalleries.data){
            for(const gallery of responseParsed.paginatedGalleries.data){
                gallery.selected = false;
                if (selectedGallery != null) {
                    if (selectedGallery.id == gallery.id) {
                        gallery.selected = true;
                    }
                }
            }
            this.newsletterMailEditTemplate.imagePicker.setGalleryPagination(responseParsed.paginatedGalleries);
            this.newsletterMailEditTemplate.imagePicker.setGalleryResults(responseParsed.paginatedGalleries.data);
        }

        if (responseParsed.ratios) {
            this.newsletterMailEditTemplate.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.newsletterMailEditTemplate.imagePicker.setOrientations(responseParsed.orientations);
        }

        if (responseParsed.uploadSources) {
            this.newsletterMailEditTemplate.imagePicker.setUploadSources(responseParsed.uploadSources, responseParsed.selectedUploadSource);
        }

        if (responseParsed.idBrand) {
            this.newsletterMailEditTemplate.imagePicker.setIdBrand(responseParsed.idBrand);
        }
    }


    protected bytesToSize(bytes) {
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    protected saveImages(images, insert, param, insertType='image') {

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + '/images/save/';
        const formReq_params: string[][] = [];

        formReq_params.push(["data", ko.toJSON(images)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    const response = JSON.parse(req.request.response);

                    const target = obj.newsletterMailEditTemplate.getImagePickerTarget();

                    obj.newsletterMailEditTemplate.setImagePickerTarget(null);

                    obj.newsletterMailEditTemplate.imagePicker.onImageSaveReturn(response.images, insert, param, insertType);

                    obj.getImageData();
                });

            };
        });
        XHRHdl.execute();
    }

    public reset(){

        this.newsletterMailEditTemplate.imagePicker.hidePickerUploadError();
    }

    private getNewsletterMailDataForEdit() {

        this.loadingIn(this.newsletterMailEditTemplate.builtTemplate);

        const url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/emails/get/' + this.getVnAppZone().app.params.id + '/';
        const request_parameters : string[][] = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterMailDataForEdit;
        this.XHRHdl.execute();

    }

    private onGetNewsletterMailDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);
                const newsletterMail = responseParsed.mail;
                const mode = responseParsed.mail.mode || 'regular';
                const selectedTemplateId = responseParsed.mail.selectedTemplate && responseParsed.mail.selectedTemplate.id ? responseParsed.mail.selectedTemplate.id : null;
                obj.newsletterMailEditTemplate.setNewsletterMode(mode);
                obj.newsletterMailEditTemplate.setSelectedTemplateId(selectedTemplateId);
                const selectedTemplate = obj.newsletterMailEditTemplate.getAvailableNewsLetterTemplates().find(t => t.id === selectedTemplateId);
                obj.newsletterMailEditTemplate.setSelectedTemplate(selectedTemplate || null);

                obj.initializeCkEditors(mode);
                obj.setNewsletterMailData(newsletterMail);

            });

            obj.loadingOut(obj.newsletterMailEditTemplate.builtTemplate);
        };
    }

    protected setNewsletterMailData(newsletterMail) {

        // this.initializeCkEditors();
        this.newsletterMailEditTemplate.setId(newsletterMail.id);
        this.newsletterMailEditTemplate.setSubject(newsletterMail.subject);
        this.newsletterMailEditTemplate.setPreviewText(newsletterMail.previewText);

        const content = newsletterMail.content;
        contentEditor.setData(content, function () {
            this.resetUndo();
        });

    }

    protected insertImage(image, target, extra_option:any = null) {

        if (target.element) {

            const element = target.element;
            element.parentElement.removeChild(element);
            target = target.editor;
        }

        if (target === "tagImageOverride" || target === "tagImageOverrideEdit" ) {
            this.newsletterMailEditTemplate.tagPicker.setTagImageOverride(image);
        }else if (target === "tagImageEdit") {
            this.newsletterMailEditTemplate.tagPicker.setTagImage(image);
        }else if (target === "tagIconImageEdit") {
            this.newsletterMailEditTemplate.tagPicker.setTagIconImage(image); // @TODO maybe don't do this
        }else if (target === "tagImageBadge") {
            this.newsletterMailEditTemplate.tagPicker.setTagImageBadge(image);
        }
        const newsLetterMode = this.newsletterMailEditTemplate.getNewsletterMode();

        const imgTag = this.buildImageTag(image, false, extra_option, newsLetterMode);
        if (target === "contenttext") {
            this.insertTag(imgTag, contentEditor);
        }
    }

    protected buildImageTag(image, addCaption, extraOption: any = null, newsLetterMode:string|null = null): string {
        let imgTag = '<img ';

        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        if (addCaption && image.caption != null && image.caption.trim() !== "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        if (newsLetterMode === NwsLAB.CUSTOM_CONTENT_MODE) {
            imgTag = `
            <table role="presentation" width="560" cellspacing="0" cellpadding="0" border="0">
                <tbody>
                    <tr>
                        <td align="center" style="padding-bottom: 16px;">
                            <img alt="${image.altText || ''}"src="${image.url}" style="display:block; border:0; border-radius:10px; max-width:560px; height:auto;" width="560" />
                        </td>
                    </tr>
                </tbody>
            </table>
            `;
        }

        return imgTag;
    }

    protected insertTag(tag, editor) {

        editor.insertHtml(tag);
    }

    protected addOnClickContentHandler(editors, mode:string|null = null) {
        const _myThis = this;
        editors.forEach(function (editor) {

            editor.on("pluginsLoaded", function (event) {
                editor.on('contentDom', function () {
                    const editable = editor.editable();
                    editable.attachListener(editable, 'click', function (evt) {
                        const target = evt.data.getTarget();
                        const el = target.$;
                        _myThis.onClickCkEditorElement(el, editor, mode);
                    }, null, null, 10);
                });
            });
        });
    }


    protected addHorizontalLineHandler(editor: any): void {
        editor.on('instanceReady', (e) => {
            editor.addCommand('horizontalrule', {
                exec: () => {
                    this.valnetLog('Command Triggered', 'horizontalrule');
                    const tableHtml : string =
                        `
                    <table role="presentation" width="560" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                            <td style="padding-bottom: 16px;">
                                <hr style="width: 560px;">
                            </td>
                        </tr>
                    </table>
                        `;
                    editor.insertHtml(tableHtml);
                }
            });
        });

    }

    protected addParagraphStyleHandler(editor: any): void {
        editor.on('instanceReady', () => {
            let lastExecutionTime: number | null = null;
            const delay = 100;

            editor.document.on('keyup', () => {
                this.valnetLog('Command Triggered', 'keyup');
                const now = Date.now();
                if (lastExecutionTime && now - lastExecutionTime < delay) {
                    return;
                }
                lastExecutionTime = now;

                const selection = editor.getSelection();
                if (!selection) return;

                const range = selection.getRanges()[0];
                if (!range) return;

                const startElement = range.startContainer;
                let pElement = null;

                if (startElement && startElement.is && startElement.is('p')) {
                    pElement = startElement;
                } else if (startElement && startElement.getParent && startElement.getParent().is('p')) {
                    pElement = startElement.getParent();
                }

                if (pElement) {

                    const currentStyles = pElement.getAttribute('style') || '';
                    if (!currentStyles || currentStyles.trim() === '') {
                        pElement.setAttribute('style', 'margin: 0; padding-bottom: 16px;');
                    }
                }
            });

            editor.dataProcessor.htmlFilter.addRules({
                elements: {
                    p(element) {
                        console.log(
                            "%c DataProcessor %c Triggered ",
                            "color: white; background-color: blue; font-size: 10px; padding: 4px;",
                            "color: black; background-color: yellow; font-size: 10px; padding: 4px;"
                        );
                        const currentStyles = element.attributes.style || '';
                        if (!currentStyles || currentStyles.trim() === '') {
                            element.attributes.style = 'margin: 0; padding-bottom: 16px;';
                        }
                        return element;
                    }
                }
            });
        });
    }

    /**
     * Debounce function to limit the rate at which a function can fire.
     */
    private debounce(func: any, wait: any): (...args: any[]) => void {
        let timeout;
        return function(...args : any[]): void {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    /**
     * Checks if an element is effectively empty (ignoring whitespace, non-breaking spaces, and zero-width spaces).
     */
    private isEmptyHeading(element: any): boolean {
        const textContent = element.getText().trim();
        return textContent === '' || textContent === '\u200B' || textContent === '&nbsp;';
    }


    protected wrapHeadingWithTable(editor: any, element: any, color: string|null = ''): void {
        if (element.getAscendant('table', true)) {return;}
        element.removeAttribute('style');
        element.setStyle( 'color', color );
        const tagName = element.getName().toLowerCase();
        const paddingBottom = tagName === 'h2' ? '20px' : '18px';
        const tableHtml =
        `
        <table role="presentation" width="560" cellspacing="0" cellpadding="0" border="0">
            <tr>
                <td style="padding-bottom:${paddingBottom};">
                    ${element.getOuterHtml()}
                </td>
            </tr>
        </table>
            `;
        editor.insertHtml(tableHtml);
    }

    protected commandListenerHandler(editor: any): void {
        editor.on('instanceReady', () => {
            editor.on('afterCommandExec',  (event) => {
                this.valnetLog('Command Triggered', event.data.name);
            });
        });
    }

    protected blockquoteCommandHandler(editor: any): void {
        editor.on('instanceReady', () => {
            if (editor.commands.blockquote) {
                delete editor.commands.blockquote;
            }
            // Override the blockquote default behavior
            editor.addCommand('blockquote', {
                exec: (editorInstance: any) => {

                    const selection = editorInstance.getSelection();
                    const selectedText = selection && selection.getSelectedText();

                    if (selectedText) {
                        const blockquoteHTML = `
                    <table role="presentation" width="560" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                            <td style="padding-bottom: 16px;">
                                <blockquote style="padding: 8px 16px; margin: 0; border-left: 4px solid #333333; background-color: #f9f9f9; font-style: italic; color: #555555;">
                                    ${selectedText}
                                </blockquote>
                            </td>
                        </tr>
                    </table>`;

                        editorInstance.insertHtml(blockquoteHTML);
                    }
                }
            });

            editor.config.allowedContent = true;
        });
    }

    protected cleanListStylesHandler(editor: any): void {
        editor.on('instanceReady', () => {
            editor.on('afterCommandExec', (evt: any) => {
                const commandName = evt.data.name;

                if (commandName === 'numberedlist' || commandName === 'bulletedlist') {
                    const editable = editor.editable();
                    if (!editable) return;

                    const liElements = editable.find('li');
                    for (let i = 0; i < liElements.count(); i++) {
                        const li = liElements.getItem(i);
                        if (li.hasAttribute('style')) {
                            li.removeAttribute('style');
                        }
                    }
                }
            });

            editor.config.allowedContent = true;
        });
    }
    protected onClickCkEditorElement(element, editor, mode:string|null = null) {

        const editorName = editor.name;
        // handle tag
        let foundTag = false;
        let foundGroup = false;
        const clone = element;

        const tagDisplayCard = this.isTagDisplayCard(element);

        if (tagDisplayCard.isSingleTag) {
            foundTag = true;
            element = tagDisplayCard.element;
        }

        if (tagDisplayCard.isGroupTag) {
            element = tagDisplayCard.element;
            foundGroup = true;
            foundTag = false;
        }

        if (this.newsletterMailEditTemplate.isSectionForTagPicker(editorName)) {

            if (!foundGroup && !foundTag) {

                foundGroup = true;
            }
        }

        if(foundGroup) {
            this.editTagGroupElement(element, editorName);
            return;
        }

        if(foundTag) {
            this.editTagElement(element, editorName);
            return;
        }

        // handle image
        if (element.nodeName === "IMG"){
            if(mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE){
                return;
            }
            const imgSrc = element.getAttribute("src");
            this.newsletterMailEditTemplate.setImagePickerTarget(imgSrc);

            const target = {"element":element,"editor":editorName};

            this.newsletterMailEditTemplate.showImagePicker("content-select", target);
            this.setImageMode("content-select");

            this.getImage(imgSrc);
        }
    }

    public isTagDisplayCard(element) {


        const originalElement = element;
        const elementInfo = {isSingleTag: false, isGroupTag: false, element: originalElement};

        while(element) {
            if (element.nodeName == "DIV" && element.classList.contains('emaki-displayCard') && element.classList.contains('tag')) {

                elementInfo.isSingleTag = true;
                elementInfo.element = element;
                if (element.parentNode.nodeName == "DIV" && element.parentNode.classList.contains('emaki-displayCard-group')) {

                    elementInfo.isSingleTag = false;
                    elementInfo.isGroupTag = true;
                    elementInfo.element = element.parentNode;
                    break;
                }
            }

            element = element.parentNode;
        }

        return elementInfo;
    }

    protected getImage(imgSrc){

        if (this.contentImageXHRHdl) {
            this.contentImageXHRHdl.cancelAndReset();
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;

        const formReq_url: string = '/api/brand/' + idBrand + '/images/get-content-image/';
        const formReq_params: string[][] = [];
        formReq_params.push(["imgSrc", imgSrc]);

        this.contentImageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
        this.contentImageXHRHdl.execute();
    }

    protected onImageRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                // check if user has article write permissions
                const responseParsed = JSON.parse(req.request.response);

                const image = responseParsed.image.data[0];

                obj.newsletterMailEditTemplate.imagePicker.editImage(image, obj.getImageMode());

                obj.newsletterMailEditTemplate.imagePicker.hideLoading();
            });
        };
    }

    // protected editImage(image, mode = ""){
    //     this.newsletterMailEditTemplate.imagePicker.editImage(image, mode);
    // }

    public setImageDescription(description) {

        imageDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public setImageCaption(caption) {
        imageCaptionEditor.setData(caption, function () {
            this.resetUndo();
        });
    }


    private getImageMode() : string{
        return this.imageMode;
    }

    private setImageMode(mode : string) : void {
        this.imageMode = mode;
    }

    protected editTagElement(element, editor){

        const idTag = element.getAttribute("data-id");
        this.getTag(idTag);

        this.newsletterMailEditTemplate.editTagElement(element, editor);
    }

    public getTag(tag, select = false){
        this.getTags([tag], select);
    }

    protected getTags(idTags, select = false) {

        if (this.tagXHRHdl) {
            this.tagXHRHdl.cancelAndReset();
        }

        if(idTags.length > 1){

            this.XHRHdlCaller = "tag_picker_group";
            this.newsletterMailEditTemplate.tagPicker.showLoading();
        }else{

            if(select){

                this.XHRHdlCaller = "tag_picker_select";
                this.newsletterMailEditTemplate.tagPicker.showLoading();
            }else{

                this.XHRHdlCaller = "tag_picker_view";
                this.newsletterMailEditTemplate.tagPicker.showViewLoading();
            }

        }

        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        const usrReq_params: string[][] = [];

        // let vm:any = this.newsletterMailEditTemplate.getViewModelForRequest();
        // vm.lockItem = true;

        usrReq_params.push(["data", ko.toJSON({ idTags})]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.tagXHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.tags && responseParsed.tags.length > 0) {

                    if(obj.XHRHdlCaller == "tag_picker_group"){
                        const tagsResponse = responseParsed.tags;
                        const tags = [];
                        for(const response of tagsResponse){
                            const tag = response.tag;
                            tag.specsValues = response.specsValues;
                            tag.specDefaults = response.specDefaults;
                            tag.communityRating = response.communityRating? response.communityRating : { average: null, count: 0 };
                            tag.includeCommunityRating = response.includeCommunityRating? response.includeCommunityRating : false;
                            tags.push(tag);
                        }
                        obj.newsletterMailEditTemplate.tagPicker.selectTags(tags);
                    }else{
                        const tag = responseParsed.tags[0].tag;
                        tag.specsValues =  responseParsed.tags[0].specsValues;
                        tag.specDefaults =  responseParsed.tags[0].specDefaults;
                        tag.communityRating = responseParsed.tags[0].communityRating? responseParsed.tags[0].communityRating : { average: null, count: 0 };
                        tag.includeCommunityRating = responseParsed.tags[0].includeCommunityRating? responseParsed.tags[0].includeCommunityRating : false;
                        if(obj.XHRHdlCaller == "tag_picker_select"){
                            obj.newsletterMailEditTemplate.tagPicker.selectTag({... tag, pros : [], cons : [] }, true);
                        }else if(obj.XHRHdlCaller == "tag_picker_view"){
                            obj.newsletterMailEditTemplate.tagPicker.setTag({... tag, pros : [], cons : [] });
                        }
                    }


                }
                // obj.editForm.setPermissions(responseParsed.permissions);
            });

            obj.newsletterMailEditTemplate.tagPicker.hideViewLoading();
            obj.newsletterMailEditTemplate.tagPicker.hideLoading();
            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.newsletterMailEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.newsletterMailEditTemplate.removeTagPickerValidationClass();
            }
        };
    }
    protected editTagGroupElement(element, editor){

        const tagIds = [];
        for (const child of element.childNodes){
            if(child.nodeName == "DIV" && child.className == "emaki-displayCard tag"){

                const idTag = child.getAttribute("data-id");
                if(idTag != null){
                    tagIds.push(idTag);
                }
            }

        }

        if(tagIds.length == 1){
            this.getTags(tagIds);
            this.newsletterMailEditTemplate.editTagElement(element, editor);
        }else if(tagIds.length > 1){
            this.getTags(tagIds);
            this.newsletterMailEditTemplate.editTagGroup(element, editor);
        }

    }

    protected getArticlesSuggestion(keyword, idElement) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        const subViewModel = {list: {keyword}, idElement};
        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4 && req.request.status == 200) {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.articles) {
                    obj.newsletterMailEditTemplate.articleFilter.setOptions(responseParsed.data.articles);
                }
            }
        };
    }


    protected getArticlePreview(article) {

        this.loadingIn(document.getElementsByClassName('w-article-picker')[0]);

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        const idArticle = article.id;
        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/article/previewNoSave/"+ idArticle +"/";
        const usrReq_params: string[][] = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGetArticlePreviewReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlePreviewReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                const responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.insertArticlePreviewContent(responseParsed.data);

                }else{

                    obj.validationTemplate.setSingleMessage({
                        field: "error",
                        "label": req.request.status,
                        message: responseParsed.message
                    });
                    window.scrollTo(0, 0);
                }
                obj.loadingOut(document.getElementsByClassName('w-article-picker')[0]);
            }
        };
    }

    protected insertArticlePreviewContent(data): void {
        if (!data) {
            this.newsletterMailEditTemplate.setArticleInsertPreviewCode('');
            return;
        }

        const article = data.article;
        if (!article) {
            this.newsletterMailEditTemplate.setArticleInsertPreviewCode('');
            return;
        }

        const articleBrand = article.brand || {};
        const emakiPreview = data.emakiPreview || {};
        const contentBlocks: any[] = emakiPreview.contentBlocks || [];
        const postType = emakiPreview.postType;
        // const commentCount = emakiPreview.commentCount;
        const datePublished = emakiPreview.datePublished;

        const firstParagraph = (contentBlocks.find(({ type }) => type === 'paragraph') || { text: '' }).text;

        const articlePermalink = articleBrand.domain ? `https://${articleBrand.domain}${article.permalink}` : '';

        const firstAuthor = emakiPreview._firstAuthor || {};

        let authorDetails = {
            authorName: firstAuthor.name ||`${data.brand.shortName || 'BRAND'} Staff`,
            authorPicture : (data.cdn.imageUploadUrl) ? `${data.cdn.imageUploadUrl}/profilepics/circle-user-solid-1.png` : '',
            authorUrl : null
        } as any;

        if(articleBrand.domain && firstAuthor.niceName) {
            authorDetails.authorUrl = `https://${articleBrand.domain}/author/${firstAuthor.niceName}`;
        }

        if(postType === 'thread'){
            authorDetails = {
                authorName: emakiPreview.promptAuthorDisplayName || `${data.brand.shortName || 'BRAND'} Member`,
                authorPicture: emakiPreview.promptAuthorPicture || ((data.cdn.imageUploadUrl) ? `${data.cdn.imageUploadUrl}/profilepics/circle-user-solid-1.png` : ''),
                authorUrl: null
            };
            if(emakiPreview.promptAuthorIdProfile && articleBrand.domain){
                authorDetails.authorUrl = `https://${articleBrand.domain}/profile/${emakiPreview.promptAuthorIdProfile}`;
            }
        }

        if(firstAuthor.pictureUrl && data.cdn.imageUploadUrl){
            authorDetails.authorPicture = `${data.cdn.imageBrandInfoBaseUrl}/${firstAuthor.pictureUrl}`;
        }

        const mode = this.newsletterMailEditTemplate.getNewsletterMode();
        const colorSet = this.getColorSet();
        const articlePickerBuilder = new NwsLAB(mode, colorSet);

        articlePickerBuilder
            .createTitle(article.title, articlePermalink)
            .createExcerpt(article.excerpt)
            .createFeaturedImage(article.featuredImage, articlePermalink)
            .createContent(firstParagraph)
            .createReadMoreLink(articlePermalink);

        if(mode === NwsLAB.CUSTOM_CONTENT_MODE || mode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE){
            articlePickerBuilder.createAuthor( authorDetails, datePublished);
        }

        articlePickerBuilder.buildArticlePreview();

        this.newsletterMailEditTemplate.setArticleInsertPreviewCode(articlePickerBuilder.htmlString);
        this.newsletterMailEditTemplate.setFinalPreviewElementId(articlePickerBuilder.randomId);
    }

    protected showInsertArticlePopUp(editor){

        this.newsletterMailEditTemplate.toggleArticleInsertPopUp(true);
    }

    protected filterSimpleOnChange(idElement){

        switch (idElement) {
            case "filterTagSearch":
                this.newsletterMailEditTemplate.tagPicker.resetPagination();
                this.getTagData();
                break;
            case "filterArticle":
                const article = this.newsletterMailEditTemplate.articleFilter.getTemplateViewModel().articleObj();
                if(article){
                    this.validationTemplate.clearMessages(); // clear validation
                    this.newsletterMailEditTemplate.setArticleInsertPreviewCode(''); // clear preview code
                    this.getArticlePreview(article);
                }
                break;
            default:
                this.getImageData();
                break;

        }
    }

    public insertIntoEditor(data) {

        const selectionElement = contentEditor.getSelection().getStartElement();
        const range = contentEditor.createRange();
        range.setStartAt( selectionElement, CKEDITOR.POSITION_AFTER_END );
        range.collapse( true );

        // remove class and then insert
        data = data.replaceAll('class="disable"', '');
        contentEditor.insertHtml(data, range);
    }

    protected updateTagPickerForm(responseParsed) {
        const selectedTags = this.newsletterMailEditTemplate.tagPicker.getSelectedTags();

        if( responseParsed.data ){
            for(const tag of responseParsed.data){
                tag.selected = false;
                const tagSelected = selectedTags.find(i => i.id == tag.id);
                if (tagSelected) {
                    tag.selected = true;
                }
            }
            this.newsletterMailEditTemplate.tagPicker.setTagsPagination(responseParsed.totalPage, responseParsed.currentPage);
            this.newsletterMailEditTemplate.tagPicker.setTagResults(responseParsed.data);
        }

    }

    protected onAutocompleteInputClear(idElement) {

        if ( idElement == "filterAutocompleteProductType_template" ){

            this.newsletterMailEditTemplate.filterProducts.setOptions([]);

            if ( this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().optionObj() ) {

                this.newsletterMailEditTemplate.filterProducts.clearInput();
            }

            this.newsletterMailEditTemplate.onChangeSelectTag();

        } else if ( idElement == "filterAutocompleteProduct_template" ) {

            this.newsletterMailEditTemplate.onChangeSelectTag();

        }
    }

    protected insertTagElement(elementToReplace, element, target){

        if(elementToReplace != null && elementToReplace.parentElement != null){
            elementToReplace.parentElement.removeChild(elementToReplace);
        }
        const editor = this.getEditor(target);

        // set cursor position to end of current selection - to insert tag after elements
        if(editor != null){


                let range = null;
                const selectionElement = editor.getSelection().getStartElement();

                if(selectionElement != null && selectionElement.$ && selectionElement.$.nodeName != "BODY"  && selectionElement.getParent() != null){
                    range = editor.createRange();
                    range.setStartAt( selectionElement, CKEDITOR.POSITION_AFTER_END );
                    range.collapse( true );
                }else if(selectionElement == null){
                    range = editor.createRange();
                    range.moveToElementEditEnd( range.root );
                }
                editor.insertHtml(element, 'html', range);
            }
    }

    protected getEditor(target){

        let editor = null;
        switch (target){
            case "contenttext":
                editor = contentEditor;
                break;
        }

        return editor;

    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected handleFiles(files) {

        this.uploadImages(files);

    }

    protected uploadImages(files) {


        console.log('trial  - ' + this.uploadStatus.currentTrial);

        const parent = this;
        const idBrand = this.getVnAppZone().app.params.idBrand;
        const formReq_url: string = '/api/brand/' + idBrand + '/images/upload/';

        const formData = new FormData();

        this.initializeProgress(files.length);

        if (files.length > 1) {

            this.newsletterMailEditTemplate.imagePicker.showLoading();
        }

        this.newsletterMailEditTemplate.imagePicker.clearFilters();

        // upload status vars.
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {

            formData.append("file_" + i, files[i]);

        }
        formData.append("idBrand", idBrand);

        const request = [];
        const xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        const onReadyStateFunction = (function (req, obj) {

            return function () {

                if (req.request.readyState == 4) {

                    if (req.request.status == 200) {

                        // reset the upload status when successful operation is complete.
                        obj.uploadStatus.reset();
                        const fileElement: any = document.getElementById("fileElem");
                        fileElement.value = '';
                        const response = JSON.parse(req.request.response);

                        obj.updateProgress(response.images.length, 100); // <- Add this

                        if (response.images.length == 1 && response.errors.length == 0) {

                            obj.newsletterMailEditTemplate.imagePicker.editImage(response.images[0]);
                            obj.newsletterMailEditTemplate.imagePicker.hideLoading();
                        }

                        if ((response.images.length == 1 && response.errors.length == 1) || response.images.length > 1) {

                            obj.newsletterMailEditTemplate.imagePicker.hideImageAdd();
                            obj.newsletterMailEditTemplate.imagePicker.handleBulkImages(response.images);
                            obj.newsletterMailEditTemplate.imagePicker.hideLoading();

                            if (response.errors.length == 1) {
                                obj.newsletterMailEditTemplate.imagePicker.imagesBulkEdit.validationsList.setMessages(response.errors);
                            }
                        }

                        obj.resetProgress();
                        obj.validationTemplate.clearMessages();

                    } else if (req.request.status == 400) {

                        const responseParsed = JSON.parse(req.request.response);
                        obj.newsletterMailEditTemplate.imagePicker.imageAdd.validationsList.setMessages(responseParsed.validations);
                        obj.newsletterMailEditTemplate.imagePicker.hideLoading();
                        window.scrollTo(0, 0);

                    } else {
                        obj.uploadStatus.isInProgress = false;
                        obj.newsletterMailEditTemplate.imagePicker.showUploadError();
                    }
                }

            };
        });

        // call on request changes state
        xhttp.onreadystatechange = onReadyStateFunction(request, this);

        let firstTime = new Date().getTime();
        xhttp.upload.addEventListener("progress", function (e) {

            parent.uploadStatus.progress = e.loaded;
            const progressTime = new Date().getTime();
            const diff =  progressTime - firstTime;
            firstTime = progressTime;
            console.log('Upload Image progress: ', e.loaded, e.total, parent.uploadStatus.progress, diff);
        });

        xhttp.upload.addEventListener('loadend', (e) => {

            if (!parent.uploadStatus.isInProgress && parent.uploadStatus.trialsReached()) {
                xhttp.abort();
                parent.newsletterMailEditTemplate.imagePicker.showPickerUploadError();
                parent.newsletterMailEditTemplate.imagePicker.hideLoading();
            }
            console.log('Upload Image Loadend: ', parent.uploadStatus.progress, e.loaded, e.total);
        });

        xhttp.upload.addEventListener('loadstart', (e) => {

            console.log('timeout started');
            setTimeout(() => {

                // check after one second if the progress is blocked then trigger another try.
                if (!parent.uploadStatus.isInProgress && !parent.uploadStatus.trialsReached()) {
                    xhttp.abort();
                    parent.uploadImages(files);
                }
            }, 1000);

        });

        // Send request with data
        xhttp.send(formData);
    }

    protected initializeProgress(numFiles) {
        this.progressBar = (document.getElementById('progress-bar') as HTMLProgressElement);
        this.progressBar.value = 0;
        this.uploadProgress = [];

        for (let i = numFiles; i > 0; i--) {
            this.uploadProgress.push(0);
        }
    }

    protected resetProgress() {
        this.progressBar = (document.getElementById('progress-bar') as HTMLProgressElement);
        this.progressBar.value = 0;
    }

    protected updateProgress(fileNumber, percent): void {

        this.progressBar.value = percent;
    }

    public getImageCaption(description) {
        return imageCaptionEditor.getData();
    }

    public getImageDescription(description) {

        return imageDescriptionEditor.getData();
    }

    public setTagEditLock(tag){

        this.newsletterMailEditTemplate.tagPicker.showViewLoading();
        this.XHRHdlCaller = "tag_picker_edit";
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const usrReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/get/";

        const usrReq_params: string[][] = [];

        usrReq_params.push(["data", ko.toJSON({ idTags: [tag.id] , lockItem : true })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();
    }

    public releaseBrandTagLock(idTag){

        this.XHRHdlCaller = "tag_picker_edit_cancel";
        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        const usrReq_url = `/api/brand/${idBrand}/tags/release/${idTag}`;

        const usrReq_params: string[][] = [];

        usrReq_params.push(["data", ko.toJSON({ idTag })]);

        this.tagXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.tagXHRHdl.onReadyStateFunction = this.sendSimpleRequest;
        this.tagXHRHdl.execute();

    }

    private sendSimpleRequest(req, obj) {


        return () => {

            if (req.request.readyState == 4) {

                const responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.newsletterMailEditTemplate.handleTagInArticle(obj.XHRHdlCaller);

                } else if (req.request.status == 423) {

                    if (obj.XHRHdlCaller == "tag_picker_edit_cancel") {

                        obj.newsletterMailEditTemplate.handleTagInArticle(obj.XHRHdlCaller);
                    } else {

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        obj.getVnAppZone().showNotificationToModule();
                    }

                }

                obj.newsletterMailEditTemplate.tagPicker.hideViewLoading();
            }
        };

    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" )
        {

            const filterTypes = this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.newsletterMailEditTemplate.filterProducts.setOptions([]);

            }
        }
        if ( idElement == "filterAutocompleteProductType_template" ) {
            // this.newsletterMailEditTemplate.onChangeSelectTag(); //May be unnecessary
        }

    }

    protected onAutocompleteAddNewSelected(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" ) {

            this.newsletterMailEditTemplate.getTemplateViewModel().addedReviewItemTagSpecifications([]);
            this.newsletterMailEditTemplate.onChangeSelectTag();
        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {
            // Clearing product when a new type is selected
            this.newsletterMailEditTemplate.getTemplateViewModel().addedReviewItemTagSpecifications([]);
            if ( this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel().addNewSelected() && ! this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().addNewSelected() ) {

                this.newsletterMailEditTemplate.filterProducts.clearEverything();
            }
            this.newsletterMailEditTemplate.onChangeSelectTag();
        }
    }

    protected onAutocompleteAddNewInputClick(idElement) { // TODO: May be useless

        if ( idElement == "filterAutocompleteProduct_template" ) {

        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {

        }

    }

    protected onAutocompleteAcceptSuggestion(idElement) {

        if ( idElement == "filterAutocompleteProduct_template" ) {

            const filterProducts = this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel();
            // let filterTypes = this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();

            if (filterProducts.optionObj().type)
            {
                this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel().addNewSelected(false);
                this.newsletterMailEditTemplate.filterProductTypes.setOption(filterProducts.optionObj().type);
            }


        }
    }

    protected onAutocompleteAddNewInputChange(idElement : string) {

        this.XHRHdlCaller = "onAutocompleteAddNewInputChange_" + idElement;

        if ( idElement == "filterAutocompleteProduct_template" )
        {
            const filterTypes = this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();
            const filterProducts = this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel();
            let idType;
            if (! filterTypes.addNewSelected() ) {
                idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

                if ( filterTypes.optionObj() )
                {
                    idType = filterTypes.optionObj().id;
                }
                else {
                    idType = 0;
                }
            }
            else {
                idType = 0;
            }
            this.getTagsByType(idType, filterProducts.newOptionName(), 1, true);

        }
        else if ( idElement == "filterAutocompleteProductType_template" ) {

            const filterTypes = this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();
            this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel().suggestedObj(""); // TODO: Investigate why this is needed
            this.getTagsTypeSuggestion(filterTypes.newOptionName(), 1);

        }
        else if  ( idElement == "filterAutocompleteAffiliate_template" ) {
            this.getAffiliatesSuggestion(this.newsletterMailEditTemplate.filterAffiliates.getTemplateViewModel().newOptionName(), 1);
        }

    }

    protected getTagsByType(idType, keyword = null, limit = null, typeIsNotNull = false){

        // LOADING : starts

        const subViewModel = {filter: {keyword, limit}, typeIsNotNull};

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        // this.loadingIn(this.newsletterMailEditTemplate.builtTemplate);

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/tags/get_by_type_for_review_item/'  + idType;
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                // check if user has article write permissions
                const responseParsed = JSON.parse(req.request.response);

                const tags = responseParsed.data;

                if ( obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteProduct_template") {

                    if (tags) {

                        obj.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().suggestedObj(tags[0]);
                    }

                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteProduct_template")
                {
                    tags.forEach( tag => {
                        if (tag.type != null) {
                            tag.displayNameComplement = tag.name + ' ( ' + tag.type.name + ' ) ';
                        } else {
                            tag.displayNameComplement = tag.name + ' ( * No type * )';
                        }

                        if (tag.details != null){

                            tag.isSelectable = tag.details.isSelectable;
                        }else{

                            tag.isSelectable = false;
                        }

                    });

                    obj.newsletterMailEditTemplate.filterProducts.setOptions(tags);
                    obj.newsletterMailEditTemplate.filterProducts.setIsLoading(false);

                }

            });
            obj.loadingOut(obj.newsletterMailEditTemplate.builtTemplate);
        };
    }

    protected getTagsTypeSuggestion(keyword, limit, restrictOwnedTagTypes = false) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        const subViewModel = {filter: {keyword, limit, restrictOwnedTagTypes}};
        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/type/";
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);
                const tagTypes = responseParsed.data.tagTypes;
                if (obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteProductType_template")
                {
                    obj.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel().suggestedObj(tagTypes[0]);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteProductType_template")
                {
                    obj.newsletterMailEditTemplate.filterProductTypes.setOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterTagType")
                {
                    obj.newsletterMailEditTemplate.tagPicker.setTagTypeOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAddNewTagType")
                {
                    // const idBrand = obj.getVnAppZone().app.params.idBrand;
                    // filter out owned tag types that aren't owned by this brand.
                    // tagTypes = tagTypes.filter((tagType: emaki_tag_type) => tagType.brandOwner? tagType.brandOwner.id == idBrand : true);

                    obj.newsletterMailEditTemplate.tagPicker.setAddNewTagTypeOptions(tagTypes);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterEditTagType")
                {
                    obj.newsletterMailEditTemplate.tagPicker.setEditTagTypeOptions(tagTypes);
                }


            });
        };
    }
    protected getAffiliatesSuggestion(keyword, limit) {


        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        const subViewModel = {filter: {keyword, limit}};
        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/affiliate/";
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetAffiliatesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);

                if (obj.XHRHdlCaller == "onAutocompleteAddNewInputChange_filterAutocompleteAffiliate_template") {

                    obj.newsletterMailEditTemplate.filterAffiliates.getTemplateViewModel().suggestedObj(responseParsed.affiliates[0]);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteAffiliate_template") {

                    obj.newsletterMailEditTemplate.filterAffiliates.setOptions(responseParsed.affiliates);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteTagViewAffiliate_template") {

                    obj.newsletterMailEditTemplate.tagPicker.setTagViewAffiliateFilterOptions(responseParsed.affiliates);
                }
                else if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteTagEditAffiliate_template") {

                    obj.newsletterMailEditTemplate.tagPicker.setTagEditAffiliateFilterOptions(responseParsed.affiliates);
                }
            });
        };
    }

    protected getSuggestions(keyword, idSourceElement) {
        this.XHRHdlCaller = "getSuggestions_" + idSourceElement;
        if (idSourceElement == "filterAutocompleteProduct_template") {

            const filterTypes =  this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();
            const idType = filterTypes.optionObj() ? filterTypes.optionObj().id : 0;

            if (!filterTypes.addNewSelected()) {

                this.getTagsByType(idType, this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().inputText(), 5, true);
            }
            else {
                this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().optionsLoading(false);
            }
        }
        else if (idSourceElement == "filterAutocompleteProductType_template") {

            const filterTypes =  this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();
            this.getTagsTypeSuggestion( filterTypes.inputText(), 5);

        }
        else if (idSourceElement == "filterAutocompleteAffiliate_template") {

            const filterAffiliates =  this.newsletterMailEditTemplate.filterAffiliates.getTemplateViewModel();
            this.getAffiliatesSuggestion( filterAffiliates.inputText(), 5);

        }
        // TODO here for  idSource Element use getTagSuggestions (already made)

        else if (idSourceElement == "filterTagType"){

            this.getTagsTypeSuggestion( keyword, 5);
        }
        else if (idSourceElement == "filterAddNewTagType" || idSourceElement == "filterEditTagType"){

            this.getTagsTypeSuggestion( keyword, 5, true);
        }
        else if (idSourceElement == "filterAutocompleteTagViewAffiliate_template" || idSourceElement == "filterAutocompleteTagEditAffiliate_template") {

            this.getAffiliatesSuggestion(keyword, 5);
        }

    }

    protected onAutocompleteOptionChange(idElement) {

        this.clearValidationErrors();

        if (idElement === "filterAutocompleteTagEditAffiliate_template") {

            this.newsletterMailEditTemplate.tagPicker.updateTagEditAutomaticPricingOptions();
        }

        else if (idElement === "filterAutocompleteTagViewAffiliate_template") {
            this.newsletterMailEditTemplate.tagPicker.updateTagViewAutomaticPricingOptions();
        }

        else if ( idElement == "filterAutocompleteProductType_template" ){

            this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel().options([]);
            const filterProducts = this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel();
            const product = filterProducts.optionObj();

            if (product) {

                if (product.type) {

                    this.newsletterMailEditTemplate.filterProducts.clearSelectedOption();
                }

            }


            this.newsletterMailEditTemplate.onChangeSelectTag();
        } else if ( idElement == "filterAutocompleteProduct_template" ){

            const filterTypes = this.newsletterMailEditTemplate.filterProductTypes.getTemplateViewModel();
            const filterProducts = this.newsletterMailEditTemplate.filterProducts.getTemplateViewModel();

            if (!filterTypes.addNewSelected()) {

                const tag = filterProducts.optionObj();
                if (filterTypes.optionObj() === null) {

                    if ( tag && tag.type ) {

                        filterTypes.optionObj(tag.type);
                        filterTypes.inputText(tag.type.name);
                    }
                }
                else if (tag.type.id === filterTypes.optionObj().id ) { // Added after the anna struggle BEGIN

                    if (tag.type.fields) {
                        if (tag.type.fields.length > filterTypes.optionObj().fields.length) {
                            filterTypes.optionObj(tag.type);
                        }
                    }

                }// Added after the anna struggle END
            }
            this.newsletterMailEditTemplate.onChangeSelectTag();
        }
        else if ( idElement == "filterAutocompleteAffiliate_template" ){

            if (this.newsletterMailEditTemplate.filterAffiliates.getTemplateViewModel().optionObj()) {

                this.newsletterMailEditTemplate.filterAffiliates.getTemplateViewModel().placeholder("Affiliate Partner");
            }
        }
        else if (idElement == "filterTagType") {

            this.newsletterMailEditTemplate.tagPicker.onAddTagTypeFilter();
        }
        else if ( idElement == "filterEditTagType" ){

            this.newsletterMailEditTemplate.tagPicker.onEditTagTypeFilter();
        }

    }

    public clearValidationErrors(){

        this.validationTemplate.clearMessages();
        this.newsletterMailEditTemplate.removeValidationClass();
    }

    protected saveTag(saveData) {

        this.newsletterMailEditTemplate.tagPicker.showEditLoading();

        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        const formReq_url = '/api/brand/' + idBrand + "/tag-picker/tags/save/";

        const formReq_params: string[][] = [];

        formReq_params.push(["data", ko.toJSON(saveData)] );

        const XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveTagReturn;
        XHRHdl.execute();
    }


    protected onSaveTagReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                if(responseParsed.tag){

                    obj.newsletterMailEditTemplate.tagPicker.hideEdit();

                    const {tempTagItemPros, tempTagItemCons} = obj.newsletterMailEditTemplate.tagPicker.tagEdit.getTemplateViewModel();

                    const tag = responseParsed.tag;

                    tag.specsValues = responseParsed.specsValues;
                    tag.specDefaults = responseParsed.specDefaults;
                    tag.includeCommunityRating = responseParsed.includeCommunityRating;
                    tag.communityRating = responseParsed.communityRating;
                    tag.hasTagHubPage = responseParsed.hasTagHubPage;

                    if(responseParsed.newTag){
                        obj.newsletterMailEditTemplate.tagPicker.setTagAfterAddNew(tag);
                    }else{
                        obj.newsletterMailEditTemplate.tagPicker.setTagAfterSave({...tag, pros : tempTagItemPros(), cons : tempTagItemCons() });
                    }
                    obj.newsletterMailEditTemplate.tagPicker.updateSelectedTagAfterSave(tag);
                }
            });

            obj.newsletterMailEditTemplate.tagPicker.hideEditLoading();

            if(obj.validationTemplate.getTemplateViewModel().isHidden() == 0) {
                obj.newsletterMailEditTemplate.addTagPickerValidationClass();
            } else if(obj.validationTemplate.getTemplateViewModel().isHidden() == 1) {
                obj.newsletterMailEditTemplate.removeTagPickerValidationClass();
            }
        };
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public getTagToEdit() {
        return this.newsletterMailEditTemplate.tagPicker.tagView.getTag();
    }


    public filterDropdownOnChange(idElement){
        this.getImageData();
    }

    public insertVideo(param, target, data) {
        if(param === 'insert' || param === 'insert-save') {
            if(target === 'tagPickerEdit_tagVideo') {
                this.newsletterMailEditTemplate.tagPicker.tagEdit.setTagVideo(data);
                this.getVideoPickerHelper().hideVideoPicker();
            }
        }
    }

    public filterMultipleSelectorOnChange(idElement) {
        switch(idElement) {
            case 'categoryVideoFilter':
            case 'contentTypeVideoFilter':
                this.getVideoPickerHelper().resetPagination();
                this.getVideoPickerHelper().getVideosData();
                break;
            case 'filterVideoCategoryEdit':
                this.getVideoPickerHelper().getVideoPickerEditTemplate().updateSelectedCategories();
                break;
        }
    }

    public saveVideo(videoData, param?) {
        this.getVideoPickerHelper().handleSaveVideo(videoData, param);
    }

    getColorSet(): StylesOptions {
        let colorSet: StylesOptions = { primaryColor: '#000000', secondaryColor: '#000000' };
        const selectedTemplate = this.newsletterMailEditTemplate.getSelectedTemplate();
        if (selectedTemplate != null) {
            colorSet = {
                primaryColor: selectedTemplate.primaryColor.value || '',
                secondaryColor: selectedTemplate.secondaryColor.value || ''
            };
        }
        return colorSet;
    }

    getNewsLetterMode(){
        return this.newsletterMailEditTemplate.getNewsletterMode() || 'regular';
    }

    valnetLog = (title, body) => {
        console.log(
            `%c ${title} %c ${body} `,
            "color: white; background-color: blue; font-size: 10px; padding: 4px;",
            "color: black; background-color: yellow; font-size: 10px; padding: 4px;"
        );
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_mail_edit.ts